<template>
  <div class="header-log">
    <router-link to="/"><h1><span>MON</span>PERMIS.<span>FR</span></h1></router-link>
    <img src="../assets/images/logoMonPermis.png" alt="" />
  </div>

  <div class="page">
    <Toast />
    <div class="card">
      <div class="avatar">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="8" r="4"/>
          <path d="M4 20c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke-linecap="round"/>
        </svg>
      </div>

      <h2 class="title">Changer de mot de passe</h2>
      <p class="subtitle">Choisissez un nouveau mot de passe pour votre compte</p>

      <div class="field-group">
        <label class="field-label">Mot de passe</label>
        <div class="field-input-wrap">
          <input
            class="field-input"
            type="password"
            required
            id="lname"
            name="lastname"
            v-model="this.oublieForm.mdp"
            placeholder="Nouveau mot de passe"
          />
          <i
            v-if="
              this.visibilityMdp === null ||
              this.visibilityMdp.type === 'password'
            "
            class="pi pi-eye-slash field-eye"
            @click="changeMdpVisibility()"
          ></i>
          <i
            v-else-if="this.visibilityMdp.type === 'text'"
            class="pi pi-eye field-eye"
            @click="changeMdpVisibility()"
          ></i>
        </div>
      </div>

      <div class="field-group">
        <label class="field-label">Confirmer le mot de passe</label>
        <div class="field-input-wrap">
          <input
            class="field-input"
            type="password"
            required
            id="lname2"
            name="lastname"
            v-model="this.oublieForm.mdpConfirm"
            placeholder="Confirmer le mot de passe"
          />
          <i
            v-if="
              this.visibilityMdp2 === null ||
              this.visibilityMdp2.type === 'password'
            "
            class="pi pi-eye-slash field-eye"
            @click="changeMdpVisibility()"
          ></i>
          <i
            v-else-if="this.visibilityMdp.type === 'text'"
            class="pi pi-eye field-eye"
            @click="changeMdpVisibility()"
          ></i>
        </div>
      </div>

      <button class="btn-submit" type="submit" @click="patchUserMdp()">
        Changer de mot de passe
      </button>
    </div>
  </div>
</template>

<script>
import { useToast } from "primevue/usetoast";

export default {
  data() {
    return {
      oublieForm: {
        mdp: "",
        mdpConfirm: "",
      },
      visibilityMdp: null,
      visibilityMdp2: null,
      toast: useToast(),
    };
  },

  methods: {

    changeMdpVisibility() {
      this.visibilityMdp = document.getElementById("lname");
      this.visibilityMdp2 = document.getElementById("lname2");
      if (this.visibilityMdp.type === "password" && this.visibilityMdp2.type === "password") {
        this.visibilityMdp.type = "text";
        this.visibilityMdp2.type = "text";
      } else {
        this.visibilityMdp.type = "password";
        this.visibilityMdp = null;
        this.visibilityMdp2.type = "password";
        this.visibilityMdp2 = null;
      }
    },

    patchUserMdp() {
      // l'id de l'utilisateur est contenue dans l'url après la cle generé aléatoirement, pour des raisons de sécurité ,
      // il faut effectuer un calcul pour récuperer le vrai id, le calcul est l'id qui est de base multiplié par la cle aleatoire / la cle aleatoire
      var link = this.$route.fullPath.split("/");
      let cle = link[2];
      let idMultplie = link[3];
      // on passe les params de l'url qui sont en hexadecimal de base -> decimal
      let idMultplieDecimal = parseInt(idMultplie, 16);
      let cleDecimal = parseInt(cle, 16);
      let id = idMultplieDecimal / cleDecimal;

      if (this.oublieForm.mdp === this.oublieForm.mdpConfirm) {
        window.api
          .patch(`utilisateurMdp/` + id, {
            password: this.oublieForm.mdp,
          })
          .then((res) => {
            this.toast.add({
              severity: "success",
              summary: "mot de passe modifié",
              detail: "votre mot de passe a été modifié avec succès",
              life: 3000,
            });
            this.$emit("completed", res.data);
          });
        this.$router.push({ name: "Connexion" });
      } else {
        this.toast.add({
          severity: "warn",
          summary: "confirmation  incorrecte",
          detail: "Votre confirmation est incorrecte",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
div.header-log {
  display: flex;
  border-bottom: 1px solid #E2E8F0;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
}

div.header-log h1 {
  font-weight: bold;
  margin: 0;
}

div.header-log a {
  text-decoration: none;
  color: #1e293b;
}

div.header-log span {
  color: #6899f5;
}

div.header-log img {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.page {
  width: 100%;
  min-height: calc(100vh - 82px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 20px;
}

.card {
  width: 420px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eff6ff;
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 28px;
}

.field-group {
  width: 100%;
  text-align: left;
  margin-bottom: 18px;
}

.field-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 6px;
}

.field-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.field-input {
  width: 100%;
  height: 46px;
  padding: 0 42px 0 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #1e293b;
  background: #fff;
  box-sizing: border-box;
}

.field-input:focus {
  outline: none;
  border-color: #3b82f6;
}

.field-eye {
  position: absolute;
  right: 14px;
  font-size: 16px;
  color: #94a3b8;
  cursor: pointer;
}

.btn-submit {
  width: 100%;
  height: 48px;
  margin-top: 8px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-submit:hover {
  background: #2563eb;
}
</style>
